<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head"><a id="page_7"></a>CONTENTS</p>
<p class="toc"><a href="#/A_Note_To_My_Readers">A NOTE TO MY READERS</a></p>
<p class="toc"><a href="#/Introduction">INTRODUCTION</a></p>
<p class="toc"><a href="#/Rules_Of_The_Cajun_Kitchen">RULES OF THE CAJUN KITCHEN</a></p>
<p class="toc"><a href="#/Chapter1">WINTER</a></p>
<p class="toc"><span href="#/Chapter2" title="Link target outside of Sample">SPRING</span></p>
<p class="toc"><span href="#/Chapter3" title="Link target outside of Sample">SUMMER</span></p>
<p class="toc"><span href="#/Chapter4" title="Link target outside of Sample">FALL</span></p>
<p class="toc"><span href="#/Index" title="Link target outside of Sample">INDEX</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?8038c11a